import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'

export const useRouteParams = () => {
  const router = useRouter()

  const routeParams = computed<Record<string, string>>(
    () => router?.currentRoute.params
  )
  return { router, routeParams }
}
